import { Close } from '@mui/icons-material'
import { alpha, lighten, type Components, type Theme } from '@mui/material'

type MuiChipSettings = Components<Omit<Theme, 'components'>>['MuiChip']

export const MuiChip: MuiChipSettings = {
  defaultProps: {
    deleteIcon: <Close fontSize="small" />,
    size: 'small',
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      if (ownerState.variant === 'outlined') {
        const defaultColor = theme.palette.grey[900]
        const color =
          !!ownerState.color && ownerState.color !== 'default'
            ? theme.palette[ownerState.color]?.main || defaultColor
            : defaultColor

        return {
          backgroundColor: alpha(color, 0.1), // jasne tło
          color: color,
          borderColor: lighten(color, 0.7),
          fontWeight: 500,
        }
      }

      return {}
    },
  },
}
